import { ref, set, get } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetUserDataFirebase from "./GetUserDataFirebase";
import SyncReferralMapping from "./SyncReferralMapping";

const AddUserDataInFirebase = async (state, dispatch, userId, userDatas) => {

    if ((!state?.USERID || state?.USERID == null) && !userId) return null;

    const USERID = state?.USERID || userId;

    try {
        // Reference to the user's profile node
        const userRef = ref(database, `invoiceGenerator/users/${USERID?.toString()}/user`);
        const snapshot = await get(userRef);
        const userData = snapshot.val();

        // 🔹 Sync Referral Mapping (Ensure code exists and is mapped globally)
        const finalReferralCode = await SyncReferralMapping(USERID, userDatas || userData || state?.SET_USER, dispatch);

        // User profile data to store
        const userProfile = {
            social_id: userData?.social_id || userDatas?.social_id || state?.SET_USER?.user_uid,
            name: userData?.name || userDatas?.name,
            email: userData?.email || userDatas?.email,
            contact: userData?.contact || userDatas?.contact || "",
            currency: userData?.currency || userDatas?.currency,
            user_uid: userData?.user_uid || userDatas?.user_uid,
            platform: userData?.platform || userDatas?.platform || "Website",
            razorpayId: userData?.razorpayId || userDatas?.customerId || "",
            referral_code: finalReferralCode || userData?.referral_code || userDatas?.referral_code || state?.SET_USER?.referral_code || "",
            referredBy: userData?.referredBy || userDatas?.referredBy || state?.SET_USER?.referredBy || "",
            SharedCompanies: userData?.SharedCompanies || userDatas?.SharedCompanies || state?.SET_USER?.SharedCompanies || "",
        };


        // Save or overwrite the user data
        await set(userRef, userProfile);
        await GetUserDataFirebase(USERID);

        return { success: true, message: "User profile saved successfully!" };
    } catch (error) {
        console.error("Firebase Error:", error);
        return { success: false, message: error.message || "Failed to save user data" };
    }
};

export default AddUserDataInFirebase;
